import {ChangeDetectionStrategy, Component, Inject, Input} from "@angular/core";
import {Service} from "../../../models/service.model";

@Component({
  standalone: false,
  selector: 'app-service-info-button',
  templateUrl: './service-info-button.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ServiceInfoButtonComponent {
  @Input() service: Service;

  constructor(@Inject('deliveriesDialogService') private deliveriesDialogService) {
  }

  open(event) {
    event.stopPropagation();
    this.deliveriesDialogService.serviceInfo(this.service, event);
  }

}
